export default {
  blogs: state => state.blogs,
  blogCount: state => state.blogCount,
  foundBlogs: state => state.foundBlogs,
  blog: state => state.blog,
  comments: state => state.comments,
  comment: state => state.comment,
  attachments: state => state.attachments,
  blogStatus: state => state.blogStatus,
  blogType: state => state.blogType,
  searchTerm: state => state.searchTerm,
  pageSize: state => state.pageSize,
  sortBy: state => state.sortBy,
  orderBy: state => state.orderBy
}



// WEBPACK FOOTER //
// ./src/store/modules/blog/getters.js